import { render, staticRenderFns } from "./zhuanfa.vue?vue&type=template&id=34a025a3&scoped=true"
import script from "./zhuanfa.vue?vue&type=script&lang=js"
export * from "./zhuanfa.vue?vue&type=script&lang=js"
import style0 from "./zhuanfa.vue?vue&type=style&index=0&id=34a025a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a025a3",
  null
  
)

export default component.exports